import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as accountRcsBotConfigsActions from "../actions/account_rcs_bot_configs_actions";
import * as accountRcsBotConfigsTypes from "../types/account_rcs_bots_types";
import { dispatchSnackbarError, dispatchSnackbarSuccess } from "../../../../utils/toaster";

function* getListOfRcsBotConfigs(action) {
  try {
    const res = yield call(api.get, `${endpoints.GET_RCS_BOT_CONFIGS}/${action.payload.accountId}`,action.payload);
    if (res.status === 200) {
      // dispatchSnackbarSuccess(res.data.message);
      yield put(accountRcsBotConfigsActions.getListOfRcsBotConfigsSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountRcsBotConfigsActions.getListOfRcsBotConfigsFailure(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountRcsBotConfigsActions.getListOfRcsBotConfigsFailure(e));
  }
}
//Add new bot
function* addRcsBotConfig(action) {
  try {
    const res = yield call(api.post, `${endpoints.CREATE_RCS_BOT_CONFIG}/${action.payload.accountId}`, action.payload);
    if (res.status === 200) {
      dispatchSnackbarSuccess(res.data.message);
      yield put(accountRcsBotConfigsActions.addRcsBotConfigSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountRcsBotConfigsActions.addRcsBotConfigFailure(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountRcsBotConfigsActions.addRcsBotConfigFailure(e));
  }
}

//Edit Bot
function* updateRcsBotConfig(action) {
  try {
    const res = yield call(api.patch, `${endpoints.UPDATE_RCS_BOT_CONFIG}/${action.payload.accountId}/${action.payload.data.settingId}`, action.payload.data);
    if (res.status === 200) {
      dispatchSnackbarSuccess(res.data.message);
      yield put(accountRcsBotConfigsActions.updateRcsBotConfigSuccess({ data : action.payload.data}));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountRcsBotConfigsActions.updateRcsBotConfigError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountRcsBotConfigsActions.updateRcsBotConfigError(e));
  }
}

//Delete Bot
function* deleteRcsBotConfig(action) {
  try {
    const res = yield call(api.delete, `${endpoints.DELETE_RCS_BOT_CONFIG}/${action.payload.accountId}/${action.payload.settingId}` , action.payload.data);
    if (res.status === 200) {
      dispatchSnackbarSuccess(res.data.message);
      yield put(accountRcsBotConfigsActions.deleteRcsBotConfigSuccess({settingId: action.payload.settingId}));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountRcsBotConfigsActions.deleteRcsBotConfigError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountRcsBotConfigsActions.deleteRcsBotConfigError(e));
  }
}

export default function* accountLoginSessionsSaga() {
  yield takeLatest(accountRcsBotConfigsTypes.getListOfRcsBotConfigs.GET_LIST_OF_RCS_BOT_CONFIGS_REQUEST, getListOfRcsBotConfigs);
  yield takeLatest(accountRcsBotConfigsTypes.addRcsBotConfig.ADD_RCS_BOT_CONFIG_REQUEST, addRcsBotConfig);
  yield takeLatest(accountRcsBotConfigsTypes.updateRcsBotConfig.UPDATE_RCS_BOT_CONFIG_REQUEST, updateRcsBotConfig);
  yield takeLatest(accountRcsBotConfigsTypes.deleteRcsBotConfig.DELETE_RCS_BOT_CONFIG_REQUEST, deleteRcsBotConfig);
}
